import React from 'react';
import DocTitle from 'react-document-title';

export default () => (
	<div className='Error404'>
		<DocTitle title='Page Not Found'/>
		<h1>Page Not Found</h1>
		<p>The page you are looking for does not exist, or the URL has changed.</p>
	</div>
);